// App.js
import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { Container, CssBaseline } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import { ConfigProvider } from './ConfigHolder';
import { AuthProvider, useAuth } from './AuthProvider';
// import Header from './Header';
import Login from './Login';
import MainContent from './MainContent';
// import Profile from './Profile';
// import Footer from './Footer';
import SignUp from './SignUp';
import PaymentSuccess from './PaymentSuccess';
import PaymentCancel from './PaymentCancel';
import { AutoPlayProvider } from './contexts/AutoPlayContext';
import app from './firebase'

const PrivateRoute = ({ children }) => {
  const { isAuthenticated } = useAuth();
  return isAuthenticated() ? children : <Navigate to="/login" replace />;
};

function App() {

  const theme = useTheme();
  // Determine the maximum width for the container based on the screen size
  const isDesktop = useMediaQuery(theme.breakpoints.up('lg'));
  // Use 'lg' for desktops and 'md' for mobile/portable devices
  const containerMaxWidth = isDesktop ? 'lg' : 'md';


  return (
    <AuthProvider>
      <ConfigProvider>
        <AutoPlayProvider>
        <CssBaseline />
    <Container 
      maxWidth={containerMaxWidth}
      component="main"
      sx={{ textAlign: 'left', my: 0, maxHeight: '100%', px: 0 }}
    >
 
          <Router>
          {/* <Header /> */}
            <Routes>
              <Route path = "/signup" element = {<SignUp />} />
              <Route path = "/psuccess" element = {<PaymentSuccess />} />
              <Route path = "/pcancel" element = {<PaymentCancel />} />
              <Route path="/login" element={<Login/>} />
              <Route path="/main" element={<PrivateRoute><MainContent /></PrivateRoute>} />
              {/* <Route path="/profile" element={<PrivateRoute><Profile /></PrivateRoute>} /> */}
              <Route path="/" element={<Navigate to="/main" replace />} />
            </Routes>
          {/* <Footer/> */}
          </Router>
        </Container>
      </AutoPlayProvider>
      </ConfigProvider>
    </AuthProvider>
  );
}

export default App;
